import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ProjectService } from '../../../shared/services/project.service';
import { PhaseModel, Phase } from '../../../shared/models/project.model';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-add-phase-model',
  templateUrl: './add-phase-model.html',
  imports: [FormsModule],
})
export class AddPhaseModelComponent {
  private projectService = inject(ProjectService);

  @Output() close = new EventEmitter<void>();

  isSubmitting = false;

  phaseModelData: PhaseModel = {
    modelName: '',
    phases: [{ name: '', color: '', estimatedHours: 0, order: 0 }]
  };

  addPhase() {
    this.phaseModelData.phases.push({ name: '', color: '', estimatedHours: 0, order: this.phaseModelData.phases.length });
  }

  removePhase(index: number) {
    if (this.phaseModelData.phases.length > 1) this.phaseModelData.phases.splice(index, 1);
  }

  async onSubmit() {
    if (!this.phaseModelData.modelName.trim()) {
      alert('Model name is required');
      return;
    }
    if (this.phaseModelData.phases.some(p => !p.name.trim())) {
      alert('All phases must be filled');
      return;
    }
    this.isSubmitting = true;
    try {
      this.phaseModelData.phases.forEach(phase => {
        console.log(phase.color);
      });
      await this.projectService.createPhaseList(this.phaseModelData);
      this.phaseModelData = { modelName: '', phases: [{ name: '', color: '', estimatedHours: 0 }] };
      this.close.emit();
    } catch (err) {
      console.error('Error creating phase model:', err);
      alert('Error while creating phase model');
    } finally {
      this.isSubmitting = false;
    }
  }
}
